module.exports = __webpack_public_path__ + "static/media/clutch-desktop.e47878f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clutch/clutch-desktop.png
// module id = 121
// module chunks = 0